<template>
  <div class="sn-header">
    <span class="sn-header-text">{{text}}</span>
    <span class="toggle-icon" @click="onHeaderToggleClick">
      <img v-if="arrowUp" src="../../assets/img/up-arrow.svg" alt="" width="16px" height="16px">
      <img v-else src="../../assets/img/down-arrow.svg" alt="" width="16px" height="16px">
    </span>
  </div>
</template>
<script>
export default {
  props: {
    text: {
      type: String
    }
  },
  data() {
    return {
      arrowUp: true
    };
  },
  methods: {
    onHeaderToggleClick() {
      this.arrowUp = !this.arrowUp;
      this.$emit('change', this.arrowUp);
    }
  }
};
</script>
<style lang="scss" scoped>
.sn-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding: 14px 16px;
  background-color: #ffffff;
  border-bottom: 1px solid #f2f3f7;
  .sn-header-text {
    font-size: 14px;
    font-weight: bold;
    color: #171f46;
  }
  >span {
    display: inline-block;
    &.toggle-icon {
      cursor: pointer;
    }
  }
}
</style>
